import React from "react";
import { ILevelItem } from "../../app/routes/orgChart/types";
import McDropdownNew from "../McDropdown/MCDropdownNew";

const NumberOfLevelItemsSelector: React.FC<{
  arrWithLevels: number[];
  setActiveLevel: (count: number) => void;
  activeLevel: number;
}> = ({ arrWithLevels, setActiveLevel, activeLevel }) => {
  const [levelItems, setLevelItems] = React.useState<ILevelItem[]>();

  React.useEffect(() => {
    init();
  }, [arrWithLevels?.length]);

  const init = () => {
    const _levelItems = arrWithLevels.map((item) => {
      return {
        id: item,
        displayValue: String(item),
      };
    });
    setLevelItems(_levelItems);
  };

  return (
    <>
      {levelItems != null && (
        <McDropdownNew
          color="secondary"
          buttonProps={{ style: { width: "150px" } }}
          currentValue={levelItems.find((item) => item.id === activeLevel)}
          onChange={(_, item) => setActiveLevel(item?.id)}
          options={levelItems}
          displayKey="displayValue"
          defaultTitle={`Vise nivåer ${activeLevel == null ? "" : `(${activeLevel})`}`}
        />
      )}
      {/* <Button>
        <i className="fa fa-download fa-fw" />
      </Button>
      <Button active>
        <i className="fa fa-eye fa-fw" />
      </Button>*/}
    </>
  );
};

export default NumberOfLevelItemsSelector;
